module.exports = __webpack_public_path__ + "static/obj_4@2x-f7458493165d59241d30e875243e7942.png";